import c from 'classnames';
import type * as React from 'react';
import styles from './style.m.less';

let idCounter = 0;
function generateId() {
    if (idCounter > 100000) {
        idCounter = 0;
    }
    return `react-checkbox-${idCounter++}`;
}

export type Props = {
    id?: string;
    label: string | React.ReactNode;
    ariaLabel?: string;
    description?: React.ReactNode;
    className?: string;
    pending?: boolean;
    disabled?: boolean;
    hiddenLabel?: boolean;
    compact?: boolean;
    indeterminate?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

function Checkbox({
    id: idProp,
    label,
    description,
    className,
    pending = false,
    disabled = false,
    hiddenLabel = false,
    compact = false,
    indeterminate = false,
    checked,
    ...rest
}: Props) {
    const id = idProp || generateId();
    const descriptionId = description ? `${id}-description` : undefined;

    const inputProps: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> = {
        onChange: () => {},
        'aria-describedby': descriptionId,
        'aria-label': hiddenLabel && typeof label === 'string' ? label : undefined,
        'aria-checked': indeterminate ? 'mixed' : checked,
        checked: checked,
        ...rest,
        disabled: disabled || pending,
        id,
        type: 'checkbox',

        ref: input => {
            if (input) {
                input.indeterminate = indeterminate;
            }
        },
    };

    return (
        <span className={className}>
            <input {...inputProps} />
            <label
                htmlFor={id}
                className={c({
                    [styles.pending]: pending,
                    compact: compact,
                    hiddenLabel: hiddenLabel,
                })}
            >
                {!hiddenLabel && <>{label}</>}
            </label>
            {description && (
                <div id={descriptionId} className={styles.description}>
                    {description}
                </div>
            )}
        </span>
    );
}

export default Checkbox;
